import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { TransparentButton } from '../ClickableComponents/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const DateFilterLeftOverflow = 16;
export const QuickFilterItem = ({
  textKey,
  count,
  isSelected = false,
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(Fragment, {
    children: (count > 0 || isSelected) && /*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(QuickFilterButton, {
        type: "text",
        text: `${t(textKey)} (${count})`,
        ariaLabel: t(textKey),
        isActive: isSelected,
        onClick: onClick,
        leftAligned: true,
        expand: true
      })
    })
  });
};
const QuickFilterButton = styled(TransparentButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "QuickFilterItem__QuickFilterButton",
  componentId: "sc-12x6mhk-0"
})(["padding-left:16px;padding-right:16px;"]);